import { format, formatDate, isValid } from "date-fns";

export const numberFormatter = new Intl.NumberFormat("cs-CZ");

export const floorFormatter = (
	from: number | null | undefined,
	to: number | null | undefined,
	emptyVal = "",
) => {
	if (!from && !to) return emptyVal;
	if (!from) return `${to}`;
	if (!to) return `${from}`;

	return `${from} - ${to}`;
};

export const unitFormatter = (
	val: number | null | undefined,
	unit = "m²",
	emptyVal = "",
) => {
	return val ? `${val.toLocaleString("cs-CZ")} ${unit}` : emptyVal;
};

export const moneyFormatter = (
	val: string | number | null | undefined,
	currencySign: string,
	emptyVal = "",
	decimals?: number,
) => {
	if (!val) return emptyVal;

	const numVal = Number(val);
	const formattedVal =
		decimals !== undefined ? numVal.toFixed(decimals) : numVal.toString();

	return `${Number(formattedVal).toLocaleString("cs-CZ")} ${currencySign}`;
};

export const dateFormatter = (
	val: Date | string | null | undefined,
	emptyVal = "",
	format = "dd.MM.yyyy",
) => (val ? formatDate(val, format) : emptyVal);

export const roundNumber = (val: number, decimalPlaces = 2): number =>
	Number(val.toFixed(decimalPlaces));

export const capitalizeFirstLetter = (str: string | null | undefined) => {
	if (!str) return "";

	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const nameFormatter = (
	fullName: string,
	bornDate?: string | null,
	identificationNumber?: string | null,
): string => {
	let output = fullName;

	const parsedDate = bornDate ? new Date(bornDate) : null;
	const bornDateValid = parsedDate && isValid(parsedDate);

	if (bornDateValid) {
		output += ` (${format(parsedDate, "d.M.yyyy")})`;
	} else if (identificationNumber) {
		output += ` (${identificationNumber})`;
	}

	return output;
};
